import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ValidatorsService} from "@core/validators/validators.service";
import {ParkProvider} from "@providers/park.provider";
import {ThresholdUtil} from "../../../util/threshold";

interface MyFormGroup {
  [key: string]: any;
}

@Component({
  selector: 'restroom-opening',
  templateUrl: './restroomOpening.component.html',
  styleUrls: ['./restroomOpening.component.less']
})

export class RestroomOpeningComponent implements OnInit {
  public readonly TYPE = {
    OPENING_TIME_DELAY: "OPENING_TIME_DELAY",
    OPENING_TIME: "OPENING_TIME"
  };

  public availableHours =[];
  public availableMins = [];

  @Input() restroomOpeningModel: any;
  @Input() title: string;

  public form: FormGroup;

  constructor(private fb: FormBuilder, private validator: ValidatorsService, private park: ParkProvider, private thresholdUtil: ThresholdUtil) {
    // build available hours
    for (let i = ThresholdUtil.START_TIME; i < ThresholdUtil.END_TIME; i++) {
      this.availableHours.push(this.thresholdUtil._pad(i, 2));
    }
    // build available minutes 
    for (let i = ThresholdUtil.START_MINUTES; i < ThresholdUtil.END_MINUTES; i+=ThresholdUtil.INCREMENT) {
      this.availableMins.push(this.thresholdUtil._pad(i, 2));
    }
  }

  _determineRestroomOpeningType(){
    if( this.restroomOpeningModel.type )
      return this.restroomOpeningModel.type;

    if( this.restroomOpeningModel.openingTime )
      return this.TYPE.OPENING_TIME;

    return this.TYPE.OPENING_TIME_DELAY;
  }

  ngOnInit() {
    let initRestroomOpeningType = this._determineRestroomOpeningType();
    let openingTimeDelay = this.restroomOpeningModel.openingTimeDelay ? this.restroomOpeningModel.openingTimeDelay : 0;
    let openingTimeHr = this.restroomOpeningModel.openingTime ? this.thresholdUtil.parseHour(this.restroomOpeningModel.openingTime) : null;
    let openingTimeMin = this.restroomOpeningModel.openingTime ? this.thresholdUtil.parseMin(this.restroomOpeningModel.openingTime) : null;

    this.form = this.fb.group({
      restroomOpeningType: initRestroomOpeningType,
      openingTimeDelay: [openingTimeDelay, initRestroomOpeningType == this.TYPE.OPENING_TIME_DELAY ? this.createOpeningTimeDelayFormControlValidators() : null],
      openingTimeHr: openingTimeHr,
      openingTimeMin: openingTimeMin
    } as MyFormGroup);

    this.form.controls['restroomOpeningType'].valueChanges
      .subscribe(val => {
        this.restroomOpeningModel.type = val;
        if (val == this.TYPE.OPENING_TIME) {
          this.form.controls['openingTimeDelay'].clearValidators();
          this.form.controls['openingTimeDelay'].setValue(null);
          this.form.controls['openingTimeDelay'].updateValueAndValidity({emitEvent: true});
          this.form.controls['openingTimeHr'].setValue("06");
          this.form.controls['openingTimeMin'].setValue("00");
        }else{
          this.form.controls['openingTimeHr'].setValue(null);
          this.form.controls['openingTimeMin'].setValue(null);
          this.form.controls['openingTimeDelay'].setValidators(this.createOpeningTimeDelayFormControlValidators());
          this.form.controls['openingTimeDelay'].setValue(0);
          this.form.controls['openingTimeDelay'].updateValueAndValidity({emitEvent: true});
        }
      });

    this.form.controls['openingTimeDelay'].valueChanges
      .subscribe(val => {
        this.restroomOpeningModel.openingTimeDelay = val;
      });

    this.form.controls['openingTimeHr'].valueChanges
      .subscribe(val => {
        this.restroomOpeningModel.openingTime = this.thresholdUtil.constructTime(val, this.form.controls['openingTimeMin'].value);
      });

    this.form.controls['openingTimeMin'].valueChanges
      .subscribe(val => {
        this.restroomOpeningModel.openingTime = this.thresholdUtil.constructTime(this.form.controls['openingTimeHr'].value, val);
      });
  }

  createOpeningTimeDelayFormControlValidators(){
    return [Validators.required, this.validator.isInteger];
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/restroomOpening/restroomOpening.component.ts